import { StyleSheet } from 'aphrodite';
import { THEME } from '../../../../../../../../../web/components-v2/Theme/theme';
import {
	brandPrimary,
	brandPrimaryDark,
	brandPrimaryHoverTint,
	destructive,
	gray3,
	gray4,
	success,
	titles,
	white,
} from '../../../../../../../../../web/styles/colors';

const { spacing, common, colors } = THEME;

export const styleSheet = StyleSheet.create({
	section: {
		padding: `${spacing.md}px ${spacing.lg}px`,
	},
	description: {
		fontSize: 14,
		color: gray3,
		marginBottom: spacing.md,
	},
	formGroup: {
		marginBottom: spacing.md,
	},
	formLabel: {
		fontSize: 14,
		fontWeight: 600,
		color: titles,
		marginBottom: spacing.xs,
		display: 'block',
	},
	textInput: {
		width: '100%',
		boxSizing: 'border-box' as const,
		padding: spacing.sm,
		fontSize: 14,
		fontFamily: 'inherit',
		borderRadius: common.borderRadius,
		border: `1px solid ${gray4}`,
		':focus': {
			outline: 'none',
			borderColor: brandPrimary,
		},
	},
	textArea: {
		width: '100%',
		boxSizing: 'border-box' as const,
		minHeight: 80,
		padding: spacing.sm,
		fontSize: 14,
		fontFamily: 'inherit',
		borderRadius: common.borderRadius,
		border: `1px solid ${gray4}`,
		resize: 'vertical',
		':focus': {
			outline: 'none',
			borderColor: brandPrimary,
		},
	},
	checkboxRow: {
		display: 'flex',
		alignItems: 'center',
		gap: spacing.sm,
		marginBottom: spacing.md,
	},
	checkboxLabel: {
		fontSize: 14,
		color: brandPrimaryDark,
		cursor: 'pointer',
	},
	buttonGroup: {
		display: 'flex',
		gap: spacing.sm,
		marginTop: spacing.md,
	},
	agencyList: {
		listStyle: 'none',
		padding: 0,
		margin: 0,
	},
	agencyListItem: {
		padding: `${spacing.sm}px 0`,
		borderBottom: `1px solid ${gray4}`,
		':last-child': {
			borderBottom: 'none',
		},
	},
	agencyTable: {
		width: '100%',
		borderCollapse: 'collapse',
		marginBottom: spacing.md,
	},
	agencyTableHeader: {
		backgroundColor: brandPrimaryHoverTint,
		textAlign: 'left',
	},
	agencyTableHeaderCell: {
		padding: spacing.sm,
		fontSize: 13,
		fontWeight: 600,
		color: titles,
		borderBottom: `1px solid ${gray4}`,
	},
	agencyTableRow: {
		':hover': {
			backgroundColor: brandPrimaryHoverTint,
		},
	},
	agencyTableCell: {
		padding: spacing.sm,
		fontSize: 14,
		color: brandPrimaryDark,
		borderBottom: `1px solid ${gray4}`,
		verticalAlign: 'middle',
	},
	statusCell: {
		display: 'flex',
		alignItems: 'center',
		gap: spacing.xs,
	},
	statusIcon: {
		width: 16,
		height: 16,
	},
	statusAuthorized: {
		color: success,
	},
	statusNotAuthorized: {
		color: destructive,
	},
	validationErrors: {
		backgroundColor: colors.danger.light,
		borderRadius: common.borderRadius,
		padding: spacing.md,
		marginBottom: spacing.md,
	},
	validationErrorTitle: {
		fontSize: 14,
		fontWeight: 600,
		color: destructive,
		marginBottom: spacing.xs,
	},
	validationErrorList: {
		listStyle: 'disc',
		paddingLeft: spacing.lg,
		margin: 0,
	},
	validationErrorItem: {
		fontSize: 13,
		color: destructive,
	},
	configuredSection: {
		marginTop: spacing.md,
	},
	configuredLabel: {
		fontSize: 13,
		color: gray4,
		marginBottom: spacing.xs,
	},
	configuredValue: {
		fontSize: 14,
		color: brandPrimaryDark,
	},
	loadingContainer: {
		display: 'flex',
		justifyContent: 'center',
		padding: spacing.lg,
	},
	agencyCard: {
		backgroundColor: white,
		border: `1px solid ${gray4}`,
		borderRadius: common.borderRadius,
		padding: spacing.md,
		marginTop: spacing.sm,
	},
	agencyCardHeader: {
		display: 'flex',
		justifyContent: 'space-between',
		alignItems: 'center',
	},
	agencyCardName: {
		fontSize: 14,
		fontWeight: 600,
		color: titles,
	},
	agencyCardDetails: {
		fontSize: 13,
		color: gray3,
		marginTop: spacing.xs,
	},
});
